import React from 'react';
import ProjectSidebarComponent from './ProjectSidebarComponent';
import { PageHeader } from '../../components';

const ChemicalPlantsReactorSystems: React.FC = () => {
  return (
    <>
      <PageHeader title="Chemical Plants – Reactor Systems" breadcrumbs={[{ label: "Projects", path: "/projects" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Chemical Plants – Reactor Systems</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Reactor systems form the heart of any chemical manufacturing process. At Wasser Technochem (I) Ltd., we offer supply and installation services for stainless steel, mild steel reactor systems, designed to support a wide range of chemical processes including polymerization, condensation, blending, and batch reaction systems.</p>
              <p>We ensure high-quality material selection, process piping, and equipment erection services while adhering to industry safety, pressure, and temperature standards.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-flask text-primary me-2"></i>Resin & adhesive manufacturing</p>
              <p><i className="fa fa-layer-group text-primary me-2"></i>Polyurethane/polyol blending systems</p>
              <p><i className="fa fa-seedling text-primary me-2"></i>Agrochemical & specialty chemical units</p>
              <p><i className="fa fa-paint-brush text-primary me-2"></i>Paint, coatings, and ink production</p>
              <p><i className="fa fa-vial text-primary me-2"></i>Fine chemicals & intermediate processing</p>
              <p><i className="fa fa-microscope text-primary me-2"></i>Small-scale pilot plant setups</p>

              <h3 className="mb-4">Our Capabilities</h3>
              
              <h4 className="mb-3"><i className="fa fa-cog text-primary me-2"></i>Reactor Sizes: 100 L to 25,000 L+ (customizable)</h4>
              <p>With jacketed or limpet coil heating/cooling systems.</p>

              <h4 className="mb-3"><i className="fa fa-tools text-primary me-2"></i>Supply of Associated Equipment:</h4>
              <p><i className="fa fa-circle text-primary me-2"></i>Receivers, condensers, scrubbers, reflux drums</p>
              <p><i className="fa fa-circle text-primary me-2"></i>Agitators (anchor, turbine, hydrofoil, pitched blade)</p>
              <p><i className="fa fa-circle text-primary me-2"></i>Pumps, control valves, pressure & temp instrumentation</p>

              <h4 className="mb-3"><i className="fa fa-wrench text-primary me-2"></i>Installation Scope Includes:</h4>
              <p><i className="fa fa-circle text-primary me-2"></i>Reactor installations with intermediatory piping for thermic oil, cooling systems, material loading etc.</p>
              <p><i className="fa fa-circle text-primary me-2"></i>Structural platform and foundation fabrication</p>
              <p><i className="fa fa-circle text-primary me-2"></i>Assembly of agitator drives, motor alignment</p>
              <p><i className="fa fa-circle text-primary me-2"></i>Piping for utilities (chilled water, steam, vacuum, etc.)</p>
              <p><i className="fa fa-circle text-primary me-2"></i>Electrical panel and automation-ready cabling</p>

              <h4 className="mb-3"><i className="fa fa-hammer text-primary me-2"></i>Material Options:</h4>
              <p>MS, SS316L, SS304, and Alloy Steel</p>

              <h3 className="mb-4">Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduced on-site execution time through prefabricated modules</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Safe, leak-proof, and corrosion-resistant installation</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Configured for exothermic/endothermic reactions</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Ease of scale-up and batch consistency</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compliance with ATEX, ASME, and GMP requirements</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Expertise in industrial chemical process utility integration</p>
              <p><i className="fa fa-star text-warning me-2"></i>Collaborations with reputed OEMs for brought-out items</p>
              <p><i className="fa fa-star text-warning me-2"></i>Skilled fabrication and piping crew for high-quality installation</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Experience across chemical and resin sectors</p>
            </div>

            <div className="col-lg-4">
              <ProjectSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ChemicalPlantsReactorSystems;
